module.exports = __webpack_public_path__ + "img/20038.f887ffb0.png";